import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';

@Component({
  selector: 'app-system-toggle',
  templateUrl: './toggle.component.html',
})
export class ToggleComponent {
  @Input({
    required: true,
  })
  label!: string;

  @Input() selected!: boolean;

  @Output() value = new EventEmitter<boolean>();
  constructor() {}

  onChangeValue($event: any) {
    this.value.emit($event.target.checked);
    this.selected = $event.target.checked;
  }
}

@NgModule({
  declarations: [ToggleComponent],
  imports: [],
  exports: [ToggleComponent],
})
export class SystemToggleModule {}
